export default __webpack_public_path__ + "media/images/logos/plus-divide-582c805425729259ddcc0d275c375af9.svg";